import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { Auth } from 'aws-amplify'

const invitesApi = createApi({
  reducerPath: 'invites',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://hm9c6wog8e.execute-api.sa-east-1.amazonaws.com/prod/',
    prepareHeaders: async (headers) => {
      const session = await Auth.currentSession()
      const token = session.getIdToken().getJwtToken()
      if (token) headers.set('Authorization', token)
    },
  }),
  endpoints(build) {
    return {
      fetchInvites: build.query({
        query: (chronicle_id: string) => {
          return {
            url: `/invites/${chronicle_id}`,
            method: 'GET',
          }
        },
      }),
      createInvite: build.mutation({
        query: (chronicle_id: string) => {
          return {
            url: `/invites`,
            method: 'POST',
            body: { chronicle_id },
          }
        },
      }),
      updateInvite: build.mutation({
        query: ({ invite_id, character_id }: { invite_id: string; character_id: string }) => {
          return {
            url: `/invites/${invite_id}`,
            method: 'PUT',
            body: { character_id },
          }
        },
      }),
      deleteInvite: build.mutation({
        query: (invite_id: string) => {
          return {
            url: `/invites/${invite_id}`,
            method: 'DELETE',
          }
        },
      }),
    }
  },
})

export { invitesApi }
export const {
  useFetchInvitesQuery,
  useCreateInviteMutation,
  useUpdateInviteMutation,
  useDeleteInviteMutation,
} = invitesApi
